/**
 * @generated SignedSource<<aff03b0d0f69bec1009b7de86571c81d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type atomsCurrentNotificationSectionAtomBase$data = {
  readonly __typename: "Article";
  readonly sections: ReadonlyArray<{
    readonly value: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"hooksUseNotificationsSection">;
    } | null | undefined> | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "atomsCurrentNotificationSectionAtomBase";
} | {
  readonly __typename: "Section";
  readonly fullSectionPath: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"hooksUseNotificationsSection">;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "atomsCurrentNotificationSectionAtomBase";
} | {
  // This will never be '%other', but we need some
  // value in case none of the concrete values match.
  readonly __typename: "%other";
  readonly " $fragmentType": "atomsCurrentNotificationSectionAtomBase";
};
export type atomsCurrentNotificationSectionAtomBase$key = {
  readonly " $data"?: atomsCurrentNotificationSectionAtomBase$data;
  readonly " $fragmentSpreads": FragmentRefs<"atomsCurrentNotificationSectionAtomBase">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "atomsCurrentNotificationSectionAtomBase"
};

(node as any).hash = "086fee486b4d325eb96b015f6ed588b6";

export default node;
